import { store } from '@/store/index';

const integratedAts = (
  store.getState().bootstrap?.currUser?.ats_integrated ?? []
).map((key) => key.split('/')[0]);

/**
 * Group by for table can be on of the following
 * Refer "group_by_1" - https://kula-api.postman.co/workspace/Team-Workspace~a2461b03-363f-470c-8abd-62508330d067/example/17042975-163a6e13-ab74-4935-bc3b-979699d17736
 */

export const GROUP_BY = [
  {
    name: 'Job Level',
    options: [
      { name: 'Job Title', id: 'job', supportedAts: ['all'] },
      { name: 'Status', id: 'job_status', supportedAts: ['all'] },
      {
        name: 'Sourcer',
        id: 'job_sourcer',
        supportedAts: ['ashby', 'greenhouse'],
      },
      {
        name: 'Recruiter (on job)',
        id: 'job_recruiter',
        supportedAts: ['all'],
      },
      {
        name: 'Hiring Manager',
        id: 'job_hiring_manager',
        supportedAts: ['all'],
      },
      { name: 'Department', id: 'job_department', supportedAts: ['all'] },
      { name: 'Subdepartment', id: 'job_subdepartment', supportedAts: ['all'] },
      { name: 'Office', id: 'job_office', supportedAts: ['all'] },
      { name: 'Suboffice', id: 'job_suboffice', supportedAts: ['greenhouse'] },
    ].filter(({ supportedAts }) => {
      return (
        supportedAts.includes('all') ||
        supportedAts.some((key) => integratedAts.includes(key))
      );
    }),
  },
  {
    name: 'Applications Level',
    options: [
      { name: 'Source', id: 'application_source', supportedAts: ['all'] },
      {
        name: 'Source Type',
        id: 'application_source_type',
        supportedAts: ['ashby', 'greenhouse'],
      },
      {
        name: 'Rejection Reason',
        id: 'application_rejection_reason',
        supportedAts: ['all'],
      },
      {
        name: 'Rejection Type',
        id: 'application_rejection_type',
        supportedAts: ['ashby', 'greenhouse'],
      },
    ].filter(({ supportedAts }) => {
      return (
        supportedAts.includes('all') ||
        supportedAts.some((key) => integratedAts.includes(key))
      );
    }),
  },
  {
    name: 'Candidate',
    options: [
      { name: 'Gender', id: 'candidate_gender', supportedAts: ['all'] },
      {
        name: 'Recruiter (on candidate)',
        id: 'candidate_recruiter',
        supportedAts: ['all'],
      },
    ].filter(({ supportedAts }) => {
      return (
        supportedAts.includes('all') ||
        supportedAts.some((key) => integratedAts.includes(key))
      );
    }),
  },
];

/**
 * Breakdown for table can be on of the following
 * Refer "group_by_2" - https://kula-api.postman.co/workspace/Team-Workspace~a2461b03-363f-470c-8abd-62508330d067/example/17042975-163a6e13-ab74-4935-bc3b-979699d17736
 */
export const BREAKDOWN = [
  {
    name: 'None',
    id: null,
  },
  {
    name: 'Job Breakdown',
    options: [
      { name: 'Job Title', id: 'job', supportedAts: ['all'] },
      {
        name: 'Recruiter (on job)',
        id: 'job_recruiter',
        supportedAts: ['all'],
      },
      {
        name: 'Hiring Manager',
        id: 'job_hiring_manager',
        supportedAts: ['all'],
      },
      { name: 'Department', id: 'job_department', supportedAts: ['all'] },
      { name: 'Subdepartment', id: 'job_subdepartment', supportedAts: ['all'] },
      { name: 'Office', id: 'job_office', supportedAts: ['all'] },
      { name: 'Suboffice', id: 'job_suboffice', supportedAts: ['greenhouse'] },
    ].filter(({ supportedAts }) => {
      return (
        supportedAts.includes('all') ||
        supportedAts.some((key) => integratedAts.includes(key))
      );
    }),
  },
  {
    name: 'Application Breakdown',
    options: [
      { name: 'Source', id: 'application_source', supportedAts: ['all'] },
      {
        name: 'Source Type',
        id: 'application_source_type',
        supportedAts: ['ashby', 'greenhouse'],
      },
      {
        name: 'Rejection Reason',
        id: 'application_rejection_reason',
        supportedAts: ['all'],
      },
      {
        name: 'Stage Outcome',
        id: 'application_stage_outcome',
        supportedAts: ['all'],
      },
    ].filter(({ supportedAts }) => {
      return (
        supportedAts.includes('all') ||
        supportedAts.some((key) => integratedAts.includes(key))
      );
    }),
  },
  {
    name: 'Candidate',
    options: [
      { name: 'Gender', id: 'candidate_gender', supportedAts: ['all'] },
      {
        name: 'Recruiter (on candidate)',
        id: 'candidate_recruiter',
        supportedAts: ['all'],
      },
    ].filter(({ supportedAts }) => {
      return (
        supportedAts.includes('all') ||
        supportedAts.some((key) => integratedAts.includes(key))
      );
    }),
  },
];

export const METRICS = [
  {
    name: 'Passthrough Rate',
    id: 'passthrough_rate',
  },
  {
    name: 'Overall Rate',
    id: 'overall_rate',
  },
  {
    name: 'Time in Stage',
    id: 'time_in_stage',
  },
];
